export const _LOAD_MODEL_ = 'Load:ProjectModel';
export const _SELECTED_STATUS_ = 'Selected:Status';
export const _OPEN_CONFIRMATION_ = 'Confirmation:Open';
export const _SAVE_STATUS_SUCCESS_ = 'Save:StatusSuccess';
export const _SAVE_PROJECT_SUCCESS_ = 'Save:ProjectSuccess';
export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';
export const _SAVE_PROJECT_FILE_SUCCESS_ = 'Save:ProjectFileSuccess';

export const ATTACHED = 'attached';
export const DETACHED = 'detached';

export const OPTIONS_CONFIRMATION_MODAL = {
  finish: {
    callback: 'finishProject',
    title: 'Confirme finalização da obra',
    message: 'Tem certeza que deseja finalizar esta obra?<br/>Ao fazê-lo não será mais possivel alterar os status.',
  },
  delete: {
    callback: 'deleteRow',
    title: 'Confirme exclusão de obra',
    message: 'Tem certeza que deseja excluir esse obra?',
  },
  deleteFile: {
    callback: 'deleteFile',
    title: 'Confirme exclusão de anexo',
    message: 'Tem certeza que deseja excluir esse arquivo?',
  },
  status: {
    callback: 'updateStatus',
    title: 'Confirme alteração de status',
    message: 'Tem certeza que deseja alterar o status dessa obra?<br/> Ao fazê-lo você não poderá retornar aos status anteriores!',
  },
  update: {
    callback: 'save',
    title: 'Confirme alteração de obra com status',
    message: 'Tem certeza que deseja alterar o status dessa obra?<br/> Ao fazê-lo você não poderá retornar aos status anteriores!',
  },
};

export const MODEL_STATUS = {
  id: null,
  name: '',
  icon: '',
};

export const MODEL_PROJECT_STATUS = {
  id: null,
  order: null,
  project_id: 1,
  status_id: 1,
  finished_at: null,
};

export const MODEL = {
  id: null,
  label: '',
  address: {
    city: '',
    label: 'Principal',
    state: '',
    number: '',
    street: '',
    address: '',
    country: 'BR',
    zipcode: '',
    address2: null,
    district: '',
  },
  comment: '',
  status_id: 1,
  started_at: new Date(),
  finished_at: null,
  customer_name: null,
};
